import { useCallback, useEffect, useState } from "react";
import http from "../../../../http";
import { useRecarregaAoRenovarToken } from "../../../shared/hooks/useRecarregaAoRenovarToken";

export const useBuscaListaDeIdsDeOcorrenciasComLaudo = () => {
    const [listaIdsDeOcorrenciaComLaudo, setListaIdsDeOcorrenciasComLaudo] = useState([])

    const buscaListaDeIdsDeOcorrenciasComLaudo = useCallback(() => {
        http.get('/ocorrencias-com-laudo')
        .then(res => {
            const listaOcorrencias = res.data
            setListaIdsDeOcorrenciasComLaudo(listaOcorrencias)
        })
        .catch(() => setListaIdsDeOcorrenciasComLaudo([]))
    }, [])

    useEffect(() => {
        buscaListaDeIdsDeOcorrenciasComLaudo()
    }, [buscaListaDeIdsDeOcorrenciasComLaudo])

    useRecarregaAoRenovarToken(buscaListaDeIdsDeOcorrenciasComLaudo)

    return {
        listaIdsDeOcorrenciaComLaudo
    }
}
